// extracted by mini-css-extract-plugin
export var badge = "_so-4";
export var selected = "_so-1";
export var selectedOverlay = "_so-5";
export var thumbnailButton = "_so-0";
export var thumbnailFallback = "_so-3";
export var thumbnailImage = "_so-2";